import { render, staticRenderFns } from "./UjProjektModal.vue?vue&type=template&id=49d08342&"
import script from "./UjProjektModal.vue?vue&type=script&lang=js&"
export * from "./UjProjektModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports